export default __webpack_public_path__ + "static/media/notif-ss.ae39b1a5.svg";